import type { InventoryAppOperationResult, InventoryAppSettings } from '@quds/shared';
import { apiGet, apiPost } from '@/lib/api';

export const getInventoryAppSettings = () => apiGet<InventoryAppSettings>('/inventory-app/settings');

export const activateInventoryApp = (body: { idempotencyKey: string }) =>
  apiPost<InventoryAppOperationResult>('/inventory-app/activate', body);

export const deactivateInventoryApp = (body: { idempotencyKey: string }) =>
  apiPost<InventoryAppOperationResult>('/inventory-app/deactivate', body);

export const setInventoryAppPassword = (body: { newPassword: string; idempotencyKey: string }) =>
  apiPost<InventoryAppOperationResult>('/inventory-app/password', body);

export const forceLogoutInventoryApp = (body: { idempotencyKey: string }) =>
  apiPost<InventoryAppOperationResult>('/inventory-app/force-logout', body);
